export class Mp3Recorder {
  constructor () {
    this.worker = null
    this.worklet = null
    this.inputNode = null
    this.connected = false
  }

  async configure (inputNode, channels = 2, bitRate = 128) {
    if (channels < 1 || channels > 2) {
      throw new Error('Mp3Recorder only supports mono or stereo.')
    }

    this.inputNode = inputNode

    if (this.worker == null) {
      this.worker = new Worker('/lib/Mp3RecorderWorker.js')

      await inputNode.context.audioWorklet.addModule('/lib/Mp3RecorderWorklet.js')

      this.worklet = new AudioWorkletNode(inputNode.context, 'Mp3RecorderWorklet', {
        inputChannelCount: [channels],
        channelCountMode: 'explicit',
        channelInterpretation: 'discrete'
      })

      this.worker.onmessage = e => {
        if (e.data.recordedSize != null) {
          this.onRecordedSize?.(e.data.recordedSize)
        } else if (e.data.finishedRecording) {
          this.onFinishedRecording?.(new Blob(e.data.finishedRecording, { type: 'audio/mp3' }))
        }
      }

      this.worklet.port.onmessage = e =>
        this.worker.postMessage({ message: 'receivedChannelData', channelData: e.data })
    }

    const config = { sampleRate: inputNode.context.sampleRate, bitRate, channels }
    this.worker.postMessage({ message: 'init', config })
  }

  start () {
    if (!this.connected) {
      this.worker.postMessage({ message: 'start' })
      this._connectAudioWorklet()
    }
  }

  pause () {
    this._disconnectAudioWorklet()
  }

  resume () {
    this._connectAudioWorklet()
  }

  async getRecordedSize () {
    return new Promise((resolve, reject) => {
      this.onRecordedSize = resolve
      this.worker.postMessage({ message: 'getRecordedSize' })
    })
  }

  stop () {
    this.worker.postMessage({ message: 'stop' })
    this._disconnectAudioWorklet()
    return new Promise((resolve, reject) => {
      this.onFinishedRecording = resolve
      this.worklet.port.postMessage({ message: 'stop' })
    })
  }

  _disconnectAudioWorklet () {
    if (this.connected) {
      this.inputNode.disconnect(this.worklet)
      this.connected = false
    }
  }

  _connectAudioWorklet () {
    if (!this.connected) {
      this.inputNode.connect(this.worklet)
      this.connected = true
    }
  }
}
